import HeaderBanner from "../../components/HeaderBanner/index";
import MentorMentee from "../../assets/pdf/Mentor_Mentee_IT_July25.pdf";
import MentorMenteeAS from "../../assets/pdf/Mentor_Mentee_AS_July25.pdf";
import MentorMenteeCSE from "../../assets/pdf/Mentor_Mentee_CSE_July25.pdf";
import MentorMenteeECE from "../../assets/pdf/Mentor_Mentee_ECE_July25.pdf";
import MentorMenteeHM from "../../assets/pdf/Mentor_Mentee_HM_July25.pdf";
import React from "react";
import StudentMentalHealth from "../../assets/pdf/StudentMentalHealthandWelnessCommittee.pdf";

const StudentMentoring = () => {
  document.title = "Student Mentoring & Counselling";

  // 📘 Composition of Committee PDFs
  const committeeFiles = [
    {
      title: "Student Mental Health & Wellness Committee",
      file: StudentMentalHealth,
    },
    // Add more PDFs as needed
  ];

  const communications = [
    {
      title: "Supreme Court Guidelines for Mentoring",
      file: require("../../assets/pdf/MentorMentee_Court.pdf"),
    },
    {
      title: "HelpLine Numbers for Mentors & Mentees",
      file: require("../../assets/pdf/Mento_Mentee_HelpLineNumber.pdf"),
    },
    {
      title: "HoD Underaking Format for Mentoring",
      file: require("../../assets/pdf/MentorMentee_HODMentoringUndertaking.pdf"),
    },
  ];

  // 🏫 Department-wise List of Mentors PDFs
  const departmentFiles = [
    {
      title: "IT Department Mentors-Mentee List",
      file: MentorMentee,
    },
    {
      title: "CSE Department Mentors-Mentee List",
      file: MentorMenteeCSE,
    },
    {
      title: "ECE Department Mentors-Mentee List",
      file: MentorMenteeECE,
    },
    {
      title: "Hotel Management Department Mentors-Mentee List",
      file: MentorMenteeHM,
    },
    {
      title: "Applied Science Department Mentors-Mentee List",
      file: MentorMenteeAS,
    },
    {
      title: "Management Department Mentors-Mentee List",
      file: "#",
    },
    {
      title: "Mechanical Engineering Mentors-Mentee List",
      file: "#",
    },
    {
      title: "Civil Engineering Mentors-Mentee List",
      file: "#",
    },
    {
      title: "Allied & Helth Care Mentors-Mentee List",
      file: "#",
    },
  ];

  return (
    <div>
      {/* Header Banner */}
      <HeaderBanner
        bgImage="Management"
        title="Student Mentoring & Counselling"
        currentPage="Student Mentoring & Counselling"
      />

      {/* Spacer below banner */}
      <div className="bannerBotttom h-[3.5rem] w-full"></div>

      <div className="mx-auto max-w-[1300px] px-4 pb-10">
        {/* Page Title */}
        <div className="primary-color mt-8 w-fit border-l-4 border-[#32727a] pl-3 text-2xl font-bold md:text-[45px]">
          Student Mentoring & Counselling
        </div>

        <div className="mt-8">
          <h2 className="text-xl font-semibold text-[#1d4e5f] mb-3">
            Student Mental Health & Wellness Portal{" "}
          </h2>
          <ul className="list-disc pl-6 space-y-3 text-[#333333] text-lg">
            <li>
              <a
                href="https://forms.gle/sHxSYHX82BdVBY43A"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#0056b3] hover:underline"
              >
                Click here to avail the services
              </a>
            </li>
          </ul>
        </div>

        {/* Composition of Committee */}
        <div className="mt-8">
          <h2 className="text-xl font-semibold text-[#1d4e5f] mb-3">
            Composition of Committee
          </h2>
          <ul className="list-disc pl-6 space-y-3 text-[#333333] text-lg">
            {committeeFiles.map((file, index) => (
              <li key={index}>
                <a
                  href={file.file}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#0056b3] hover:underline"
                >
                  📄 {file.title}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Department-wise List of Mentors */}
        <div className="mt-8">
          <h2 className="text-xl font-semibold text-[#1d4e5f] mb-3">
            Department-wise List of Mentors
          </h2>
          <ul className="list-disc pl-6 space-y-3 text-[#333333] text-lg">
            {departmentFiles.map((file, index) => (
              <li key={index}>
                <a
                  href={file.file}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#0056b3] hover:underline"
                >
                  📄 {file.title}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-8">
          <h2 className="text-xl font-semibold text-[#1d4e5f] mb-3">
            Commimncations & Notices related to Mentoring
          </h2>
          <ul className="list-disc pl-6 space-y-3 text-[#333333] text-lg">
            {communications.map((file, index) => (
              <li key={index}>
                <a
                  href={file.file}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#0056b3] hover:underline"
                >
                  📄 {file.title}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default StudentMentoring;
